import React from 'react';

import { PATH } from 'src/pages/multipleQuotes';
import Layout from 'src/components/layout';
import loadable from 'src/utils/loadable';
import { IRouter } from 'src/interfaces/route';
import { SCREENS } from 'src/constants/screens';

const MultipleQuotesRoute: IRouter[] = [
  {
    element: <Layout />,
    children: [
      {
        path: PATH,
        element: loadable(() => import('src/pages/multipleQuotes')),
        title: 'multiple_quotes_page.title',
        screenId: SCREENS.R1015,
      },
    ],
  },
];

export default MultipleQuotesRoute;
